// @flow
import * as React from 'react';

import { RESORT_WELLNESS } from 'Client/cms/toolkit/constants';

import { addTranslationKeys } from 'Src/i18n';

import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import { ProductWellnessLegacy } from 'Components/widgets/product-wellness-legacy/ProductWellnessLegacy.jsx';

import { productWellnessLegacyResolver } from './productWellnessLegacy.resolver';

type CMSProps = {
  resortId: string,
  title: string,
  onDemand: string,
  included: string,
  spaEquipmentTitle: string,
  age: string,
  adultsOnly: string,
  allAges: string,
  close: string,
};

type GQLProps = {
  spa: Array<Category>,
  spaDetail: Array<Category>,
  config: CMSContent,
};

type LineProps = CMSProps & GQLProps;

const ProductWellnessLegacyLine = (props: LineProps) => {
  const {
    spa: [spa],
    spaDetail = [],
  } = props;

  addTranslationKeys({
    productWellness: {
      title: props.title,
      onDemand: props.onDemand,
      included: props.included,
      equipements: props.spaEquipmentTitle,
      ages: {
        label: props.age,
        adultsOnly: props.adultsOnly,
        all: props.allAges,
      },
      year: props.config.common.participants.year,
    },
  });

  if (!spa) {
    return null;
  }

  const prestations = spaDetail.filter(prestation => prestation?.activities?.length > 0);
  const [activities = {}] = spa.activities;
  return (
    <SiteContainer className="Line">
      <ProductWellnessLegacy activities={activities} prestations={prestations} />
    </SiteContainer>
  );
};

export const productWellnessLegacyDescriptor = {
  name: RESORT_WELLNESS,
  component: ProductWellnessLegacyLine,
  props: productWellnessLegacyResolver.props,
  resolve: productWellnessLegacyResolver.resolve,
};
